import PropTypes from 'prop-types';

import { ObjectPropType } from '../../../../libs/proptypes';

export const JsonBlockPropType = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  snippets: PropTypes.arrayOf(ObjectPropType),
});
